<template>
  <div id="group-add-new-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading' && form == null" key="create-loading" />

        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("participantManagament.segmentations.groupAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("participantManagament.segmentations.groupAddUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title" :placeholder="$t('participantManagament.segmentations.groupAddUpdate.titlePlaceholder')"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("participantManagament.segmentations.groupAddUpdate.color") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("participantManagament.segmentations.groupAddUpdate.colorMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-color-picker v-model="form.color" :placeholder="$t('participantManagament.segmentations.groupAddUpdate.colorPlaceholder')"></el-color-picker>
                <span class="error">{{ $errorMessage("color", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("participantManagament.segmentations.groupAddUpdate.note") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("participantManagament.segmentations.groupAddUpdate.noteMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input type="textarea" v-model="form.description" :placeholder="$t('participantManagament.segmentations.groupAddUpdate.notePlaceholder')"></el-input>
                <span class="error">{{ $errorMessage("description", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("participantManagament.segmentations.groupAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("participantManagament.segmentations.groupAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.showOnApp ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.showOnApp ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("participantManagament.segmentations.groupAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("participantManagament.segmentations.groupAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.showOnApp"></el-switch>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
      <div class="left-buttons">
        <el-button
          @click="
            $emit('closeDialog');
            showInfo = false;
          "
          >{{ $t("participantManagament.segmentations.groupAddUpdate.close") }}</el-button
        >
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("participantManagament.segmentations.groupAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLoading'" :disabled="loading == 'saveLoading'" @click="save">{{ $t("participantManagament.segmentations.groupAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
export default {
  components: { ItemInfo },
  name: "GroupAddUpdate",
  props: ["id"],
  data() {
    return {
      settingsDock: false,
      updateForm: {},
      loading: false,
      timeout: null,
      form: null,
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false
    };
  },
  methods: {
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    async save() {
      this.loading = "saveLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("segmentation/addorupdategroup", this.form);
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          this.form = res.data.data.item;
          await this.$store.dispatch("getGroups");
        }
        this.loading = false;
      }, 500);
    }
  },

  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.id != undefined && this.id != null) {
        var res = await this.$store.dispatch("getGroupOne", this.id);
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
        } else {
          this.$emit("closeDialog");
        }
      } else {
        this.form = {
          id: null,
          title: null,
          description: null,
          color: null,
          showOnApp: true
        };
      }
      this.loading = false;
    }, 500);
  }
};
</script>
<style lang="less">
.mage-maker {
  width: 100%;
  position: relative;
  border: 1px dashed #ccc;
  height: 250px;
  background-size: contain !important;
  background-position: center center !important;
  border-radius: 5px;
  background-repeat: no-repeat !important;
  .avatar-uploader {
    opacity: 0;
    transition: all 1s;
    &:hover {
      opacity: 1 !important;
    }
    & > .el-upload {
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.group-btn-container {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  align-items: center;

  .el-button {
    padding: 4px;
    margin-left: 0;
  }
  i.el-icon-info {
    font-size: 24px;
  }
}
.model-base-small {
  min-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/GroupAddUpdate.vue